import {ERRORS} from '../../../index';

const {Component} = Shopware;
const {object} = Shopware.Utils;

Component.extend('ecocode-trustpilot-sender-name-config', 'sw-text-field-deprecated', {
    emits: ['update:value'],
    props: {
        value: {
            type: String,
            default() {
                return '';
            }
        }
    },
    data() {
        return {
            regexPattern: '^[a-zA-Z0-9\\!\\#\\s\\_\\-\\$\\%\\&\\\'\\*\\+\\-\\/\\=\\?\\^\\`\\|\\.]{2,40}$'
        };
    },
    computed: {
        inputFieldEl() {
            try {
                return document.getElementById(this.formFieldName);
            } catch (e) {
                console.info('unable to get input field element')
            }
        },
        wrapperEl() {
            try {
                if(!this.inputFieldEl){
                    return null // can happen on component rerender state
                }
                // get component wrapper element
                return this.inputFieldEl
                    .parentElement
                    .parentElement
                    .parentElement
            } catch (e) {
                console.info('unable to get wrapper element')
            }
        },
        isValid() {
            return this.validationService.regex(this.value, this.regexPattern);
        },
    },
    methods: {
        setValidationStyles() {
            if(!this.inputFieldEl){
                return null // can happen on component rerender state
            }

            this.inputFieldEl.style.color = this.isValid ?
                'inherit' : ERRORS.INVALID_VALUE_COLOR_CODE;
        },
        initEventListeners() {
            this.inputFieldEl &&
            this.inputFieldEl.addEventListener('blur', () => {
                const value = this.isValid ? this.value : '';
                this.$emit('update:value', object.cloneDeep(value.trim()));
            }, true);
        },
        removeEventListeners() {
            this.inputFieldEl &&
            this.inputFieldEl.removeEventListener('blur', () => {
                this.value = '';
            }, true);
        }
    },
    watch: {
        value() {
            this.setValidationStyles();
        }
    },
    mounted() {
        // we need timer to allow render input fields otherwise we will get error
        setTimeout(() => {
            this.setValidationStyles();
            this.initEventListeners()
        }, 0)


    },
    destroyed() {
        this.removeEventListeners()
    }
});
